import { Pipe, PipeTransform } from '@angular/core';
import { ClientSignFieldsByDocument } from '../model/sign-field.model';

@Pipe({
  name: 'collectiveDocsSignatureType',
})
export class CollectiveDocsSignatureTypePipe implements PipeTransform {
  transform(signFieldsByDocument: ClientSignFieldsByDocument): unknown {
    let collectiveSigType = null;

    for (const docSignFields of Object.values(signFieldsByDocument)) {
      for (const signField of docSignFields) {
        if (collectiveSigType === null) {
          collectiveSigType = signField.type;
        } else if (collectiveSigType !== signField.type) {
          return null;
        } else {
          // sign field type is same as the collective type
          // do nothing
        }
      }
    }
    return collectiveSigType;
  }
}
